/* eslint-disable react/prop-types */
// 公開マップに表示する一覧を作成する。

/*-------------------
    モジュールのimport
---------------------*/
import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, Polyline, Circle, Polygon } from 'react-leaflet';
import { icon } from 'leaflet';
/*-------------------
    画像のimport
---------------------*/
import iconMarker from 'leaflet/dist/images/marker-icon.png';
/*-------------------
    classのimport
---------------------*/
import * as commons from '../commons';
import { NGINX_RESIDENT_PATH } from '../constant/constant';

// 地図画面でモーダルを開く
const createModal = (imgSrc, modalMhd) => {
  const imgModal = (
    <div className="modalBack" id="img-modal">
      <div style={{ textAlign: 'right' }}>
        <button type="button" onClick={() => modalMhd([])}>
          閉じる
        </button>
        <div className="modalMain">
          <img src={imgSrc} alt="" border="0" />
        </div>
      </div>
    </div>
  );

  modalMhd(imgModal);
};

// 地図表示用
const createMap = (marker, lat, lng, tileUrl, tileAttribution) => (
  <MapContainer
    id="map"
    center={[lat, lng]}
    zoom={15}
    // className="map-test"
    style={{
      minHeight: '300px',
      width: '100%',
      height: '100%',
    }}
  >
    <TileLayer attribution={tileAttribution} url={tileUrl} />
    {marker}
  </MapContainer>
);

// 凡例の非表示リストを整形する。
const createUrl = (urlList) => {
  if (urlList.length === 0) return [];

  const content = [];
  for (let i = 0; i < urlList.length; i += 1) {
    const [url = '', title = ''] = urlList[i].split('||');
    content.push(
      <div className="popSub textRange" key={`url_${i}`}>
        <a href={url} target="_blank" rel="noreferrer noopener" className="">
          ・{title === '' ? url : title}
        </a>
      </div>
    );
  }
  return <div className="mt10">参照URL{content}</div>;
};

// 避難所の一覧作成
export function HavenTableRow(props) {
  const { data = [], comProp } = props;
  const { jpList, tileUrl, tileAttribution } = comProp;
  const { haven = '' } = jpList[0] || '';
  const { haven_class: havenClassMasta = [], disaster: disasterMasta = [] } = haven;

  const [isOpen, setIsOpen] = useState(false);

  const { current = '', station = '', point } = data;
  const {
    name = '',
    address = '',
    open_flag: openFlag = false,
    haven_class: havenClass = [],
    haven_sub_class: havenSubClass = [],
    facility_type: facilityType = [],
    tel_no: telNo = [],
    eva_level: evaLvl = [],
    elevation = '',
    limit_border: limitBorder = [],
    disaster = '',
    capacity = '',
    eq_resist: eqResist = false,
    stockpile = '',
    specified_place: specifiedPlace = '',
    acceptees = '',
    url_list: urlList = [],
  } = station;
  const { man = '', woman = '', support = '', household = '' } = current;

  // 避難所副区分の名称を取得する。
  const subClassName = [];
  for (let j = 0; j < havenClassMasta.length; j += 1) {
    const { value = '', label = '' } = havenClassMasta[j];
    if (havenSubClass.indexOf(value) !== -1) subClassName.push(label);
  }

  // 災害種別の名称を取得する。
  const disasterName = [];
  for (let j = 0; j < disasterMasta.length; j += 1) {
    const { value = '', label = '' } = disasterMasta[j];
    if (disaster.indexOf(value) !== -1) {
      disasterName.push(<div className="ml10" key={commons.randomNum()}>{`${label}：〇`}</div>);
    }
  }

  const havenClassItem = havenClassMasta.find((item) => item.value === havenClass) || '';
  const { label: havenClassName = '' } = havenClassItem;

  // 人数を計算する。
  const culcMan = man === '' ? 0 : man;
  const culcWoman = woman === '' ? 0 : woman;
  // const culcSupport = support === '' ? 0 : support;
  // const currentPeople = culcMan + culcWoman + culcSupport;
  const currentPeople = culcMan + culcWoman;
  const emptyCurrent = man === '' && woman === '' && support === '';
  const resCulc = commons.culcCapacity(capacity, limitBorder, currentPeople, emptyCurrent);
  const { rate = '', color: rateColor = '' } = resCulc;

  // 現在の状態を作成する。
  const openStat = {};
  if (openFlag === '1') {
    openStat.color = '#1f8d46';
    openStat.stat = '開設';
  } else if (openFlag === '0') {
    openStat.color = '#7e7e7e';
    openStat.stat = '閉設';
  } else {
    openStat.color = '';
    openStat.stat = '使用不可';
  }
  const { color, stat } = openStat;

  const markerIcon = icon({
    iconUrl: iconMarker,
    iconSize: [25, 41],
    iconAnchor: [12.5, 41],
  });
  const [lng, lat] = point;
  const marker = <Marker position={[lat, lng]} icon={markerIcon} />;

  const detail = (
    <div className="listDetail">
      <div className="box-dt">
        {/* TODO:以下は職員URLのみ出すかを検討する。 */}
        <div className="mt10 bold">現在の状況</div>
        <div>
          状態：<span style={{ color }}>●</span> {stat}
        </div>
        {capacity === '' ? null : <div>{`最大収容人数：${capacity}人`}</div>}
        {household === '' ? null : <div>{`世帯数：${household}`}</div>}
        {emptyCurrent === true ? null : (
          <div>
            {`収容人数：${currentPeople}人`}
            {rate === '' ? null : ` (収容率：${rate}%)`}
          </div>
        )}
        {emptyCurrent === true ? null : (
          <div>{`人数比：男性：${man === '' ? '-' : `${man}人`} , 女性：${
            woman === '' ? '-' : `${woman}人`
          } (要支援者：${support === '' ? '-' : `${support}人`})`}</div>
        )}
        <div className="mt10">{`【${havenClassName}】`}</div>
        <div className="bold">{`名称：${name}`}</div>
        <div>{`住所：${address}`}</div>
        <div>{subClassName.length === 0 ? '' : `避難所副区分：${subClassName}`}</div>
        <div>{facilityType === '' ? '' : `施設種別：${facilityType}`}</div>
        <div>{telNo === '' ? '' : `電話番号：${telNo}`}</div>
        <div>{elevation === '' ? '' : `標高：${elevation}m`}</div>
        {disasterName.length === 0 ? null : <div>対応災害{disasterName}</div>}
        {evaLvl[0] === '' && evaLvl[1] === '' ? null : (
          <div>
            緊急避難レベル
            {evaLvl[0] === '' ? null : <div className="popSub">{`風水害：レベル${evaLvl[0]}`}</div>}
            {evaLvl[1] === '' ? null : (
              <div className="popSub">&emsp;{`津波：レベル${evaLvl[1]}`}</div>
            )}
          </div>
        )}
        {eqResist === true ? <div>耐震性：あり</div> : null}
        <div>{stockpile === '' ? '' : `備蓄品：${stockpile}`}</div>
        <div>{specifiedPlace === '' ? '' : `指定場所：${specifiedPlace}`}</div>
        <div>{acceptees === '' ? '' : `受入対象者：${acceptees}`}</div>
        {createUrl(urlList)}
      </div>
      <div className="box-dt">{createMap(marker, lat, lng, tileUrl, tileAttribution)}</div>
    </div>
  );

  return (
    <>
      <tr className="table-row">
        <td>
          <span style={{ color }}>●</span> {stat}
        </td>
        <td>{havenClassName}</td>
        <td>
          <button type="button" className="toggle-btn" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? '[－]' : '[＋]'}&nbsp;
            {name}
          </button>
        </td>
        <td className="hide-col">{address}</td>
        <td className="hide-col">
          {rateColor === '' ? null : <span style={{ color: rateColor, fontSize: '18px' }}>●</span>}
          {emptyCurrent === true ? '-' : `${currentPeople}人`}
          {rate === '' ? null : `(収容率：${rate}%)`}
          {emptyCurrent === true ? null : (
            <div className="txtSmall">{`男性：${man === '' ? '-' : `${man}人`} , 女性：${
              woman === '' ? '-' : `${woman}人`
            } (要支援者：${support === '' ? '-' : `${support}人`})`}</div>
          )}
        </td>
        <td className="hide-col">{telNo}</td>
      </tr>
      {isOpen && (
        <tr className="detail-row">
          <td colSpan="5" className="detail-cell">
            {detail}
          </td>
        </tr>
      )}
    </>
  );
}

// 投稿データの一覧作成
export function PostTableRow(props) {
  const { data = [], comProp = '' } = props;
  const { tileUrl, tileAttribution, prmsn, onClickImg } = comProp;

  const [isOpen, setIsOpen] = useState(false);

  const { point, station = '', lcl_gov: lclGov = '', file_info: fileinfo = '' } = data;
  const { lg_cd: lgCd = '' } = lclGov;
  const {
    title = '',
    main,
    occurred_at: occurredAt = '',
    kind_name: kindName = '',
    disp_flag: dispFlag = '1',
    url_list: urlList = [],
  } = station;

  const { color = '', name: dispName = '', noDisp = '' } = commons.postStatus(dispFlag, false);

  // 画像リストを作成
  const imgList = [];
  for (let j = 0; j < fileinfo.length; j += 1) {
    const { name = '', public: tmpPublic = false, enable: tmpEnable = true } = fileinfo[j];

    if (tmpPublic === false || tmpEnable === false) continue;

    imgList.push(
      <button
        type="button"
        key={`img_post_${j}`}
        onClick={() => createModal(`${NGINX_RESIDENT_PATH}/${lgCd}/${name}`, onClickImg)}
      >
        <img
          key={`img_post_${j}`}
          src={`${NGINX_RESIDENT_PATH}/${lgCd}/${name}`}
          width="75"
          height="75"
          alt=""
          border="0"
          className="mr10"
        />
      </button>
    );
  }

  const markerIcon = icon({
    iconUrl: iconMarker,
    iconSize: [25, 41],
    iconAnchor: [12.5, 41],
  });
  const [lng, lat] = point;
  const marker = <Marker position={[lat, lng]} icon={markerIcon} />;

  const detail = (
    <div className="listDetail">
      <div className="box-dt">
        <div>{`【${kindName}】`}</div>
        <div>{`発生日時：${commons.changeJapanDate(occurredAt)}`}</div>
        <div className="bold">{`名称：${title}`}</div>
        {main === '' ? null : (
          <div>
            本文<div className="ml20">{commons.shapedContents(main)}</div>
          </div>
        )}
        {imgList}
        {createUrl(urlList)}
      </div>
      <div className="box-dt">{createMap(marker, lat, lng, tileUrl, tileAttribution)}</div>
    </div>
  );

  return (
    <>
      <tr className="table-row">
        {prmsn === 7 ? (
          <td className="txtCenter">
            {dispName === '' ? (
              noDisp
            ) : (
              <span className="pb-badge" style={{ backgroundColor: color }}>
                {dispName}
              </span>
            )}
          </td>
        ) : null}
        <td>{kindName}</td>
        <td>
          <button type="button" className="toggle-btn" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? '[－]' : '[＋]'}&nbsp;
            {title}
          </button>
        </td>
        <td className="hide-col">{commons.changeJapanDate(occurredAt)}</td>
        <td className="hide-col">{imgList}</td>
      </tr>
      {isOpen && (
        <tr className="detail-row">
          <td colSpan="5" className="detail-cell">
            {detail}
          </td>
        </tr>
      )}
    </>
  );
}

// 道路規制の一覧作成
export function RoadTableRow(props) {
  const { data = [], comProp } = props;
  const { jpList, tileUrl, tileAttribution } = comProp;
  const { roadclose = '' } = jpList[0] || '';
  const { kind_list: roadKind = [] } = roadclose;
  const [isOpen, setIsOpen] = useState(false);

  const { station = '' } = data;
  const {
    kind = '',
    title = '',
    main = '',
    start_time: startTime = '',
    end_time: endTime = '',
    other = '',
    inquiry = '',
    area,
    url_list: urlList = [],
  } = station;
  const [lat, lng] = area[0];

  const foundObject = roadKind.find((item) => item.value === kind);
  const { label = '' } = foundObject;

  // ラインを引く
  const marker = [];
  marker.push(<Polyline positions={area} color="#000" weight={5} key={commons.randomNum()} />);

  const detail = (
    <div className="listDetail">
      <div className="box-dt">
        <div>{`【${label}】`}</div>
        <div className="bold">{`名称：${title}`}</div>
        {main === '' ? null : (
          <div>
            本文<div className="ml20">{commons.shapedContents(main)}</div>
          </div>
        )}
        {startTime === '' ? null : <div>{`開始時間：${commons.changeJapanDate(startTime)}`}</div>}
        {endTime === '' ? null : <div>{`終了時間：${commons.changeJapanDate(endTime)}`}</div>}
        {endTime === '' ? null : <div>{`その他：${other}`}</div>}
        {endTime === '' ? null : <div>{`問い合わせ先：${inquiry}`}</div>}
        {createUrl(urlList)}
      </div>
      <div className="box-dt">{createMap(marker, lat, lng, tileUrl, tileAttribution)}</div>
    </div>
  );

  return (
    <>
      <tr className="table-row">
        <td>{label}</td>
        <td>
          <button type="button" className="toggle-btn" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? '[－]' : '[＋]'}&nbsp;
            {title}
          </button>
        </td>
        <td className="hide-col">{commons.changeJapanDate(startTime)}</td>
        <td className="hide-col">{commons.changeJapanDate(endTime)}</td>
      </tr>
      {isOpen && (
        <tr className="detail-row">
          <td colSpan="5" className="detail-cell">
            {detail}
          </td>
        </tr>
      )}
    </>
  );
}

// 屋外子局の一覧作成
export function RadioTableRow(props) {
  const { data = [], comProp } = props;
  const { tileUrl, tileAttribution } = comProp;

  const [isOpen, setIsOpen] = useState(false);

  const { station = '' } = data;
  const { name = '', cd = '', point } = station;

  const markerIcon = icon({
    iconUrl: iconMarker,
    iconSize: [25, 41],
    iconAnchor: [12.5, 41],
  });
  const [lng, lat] = point;
  const marker = <Marker position={[lat, lng]} icon={markerIcon} />;

  const detail = (
    <div className="listDetail">
      <div className="box-dt">
        <div className="bold">{`名称：${name}`}</div>
        <div>{`コード：${cd}`}</div>
      </div>
      <div className="box-dt">{createMap(marker, lat, lng, tileUrl, tileAttribution)}</div>
    </div>
  );

  return (
    <>
      <tr className="table-row">
        <td>{cd}</td>
        <td>
          <button type="button" className="toggle-btn" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? '[－]' : '[＋]'}&nbsp;
            {name}
          </button>
        </td>
      </tr>
      {isOpen && (
        <tr className="detail-row">
          <td colSpan="5" className="detail-cell">
            {detail}
          </td>
        </tr>
      )}
    </>
  );
}

// 位置情報の一覧作成
export function StandardTableRow(props) {
  const { data = [], comProp } = props;
  const { tileUrl, tileAttribution, onClickImg } = comProp;

  const [isOpen, setIsOpen] = useState(false);

  const { station = '', point } = data;
  const {
    name = '',
    kind_name: kindName = '',
    url_list: urlList = [],
    img_url_list: imgUrlList = [],
  } = station;

  const markerIcon = icon({
    iconUrl: iconMarker,
    iconSize: [25, 41],
    iconAnchor: [12.5, 41],
  });
  const [lng, lat] = point;
  const marker = <Marker position={[lat, lng]} icon={markerIcon} />;

  const imgTable = [];
  for (let j = 0; j < imgUrlList.length; j += 1) {
    const [src = '', title = ''] = imgUrlList[j].split('||');
    imgTable.push(
      <button type="button" key={`img_post_${j}`} onClick={() => createModal(src, onClickImg)}>
        <img
          key={`img_std_${j}`}
          src={src}
          width="75"
          height="75"
          alt={title}
          border="0"
          className="mr10"
        />
        {/* <span>{title}</span> */}
      </button>
    );
  }

  const detail = (
    <div className="listDetail">
      <div className="box-dt">
        {kindName === '' ? null : <div>{`【${kindName}】`}</div>}
        <div>{`名称：${name}`}</div>
        {imgTable}
        {createUrl(urlList)}
      </div>
      <div className="box-dt">{createMap(marker, lat, lng, tileUrl, tileAttribution)}</div>
    </div>
  );

  return (
    <>
      <tr className="table-row">
        <td>{kindName === '' ? 'なし' : kindName}</td>
        <td>
          <button type="button" className="toggle-btn" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? '[－]' : '[＋]'}&nbsp;
            {name}
          </button>
        </td>
      </tr>
      {isOpen && (
        <tr className="detail-row">
          <td colSpan="5" className="detail-cell">
            {detail}
          </td>
        </tr>
      )}
    </>
  );
}

// 作図エリアの一覧作成
export function AreaTableRow(props) {
  const { data = [], comProp } = props;
  const { tileUrl, tileAttribution } = comProp;

  const [isOpen, setIsOpen] = useState(false);

  const { station = '', area_list: saveMarker = '' } = data;
  const {
    name = '',
    line_color: lineColor = '#000000',
    line_opacity: lineOpacity = 1,
    line_kind: lineKind = '0',
    face_color: faceColor = '#000000',
    face_opacity: faceOpacity = 0.3,
    free_text: freeText = '',
    url_list: urlList = [],
  } = station;

  const faceRgba = commons.hexToRgb(faceColor, faceOpacity);
  const lineRgba = commons.hexToRgb(lineColor, lineOpacity);

  let borderKind = 'solid';
  if (lineKind === '1') borderKind = 'dashed';
  else if (lineKind === '2') borderKind = 'dotted';

  // エリアの疑似データ
  const rectangleStyle = {
    width: '80px' /* 幅 */,
    height: '30px' /* 高さ */,
    backgroundColor: `rgba(${faceRgba})`,
    border: `3px ${borderKind} rgba(${lineRgba})`,
    display: 'inline-block',
  };

  const marker = [];
  let lat = '';
  let lng = '';
  for (let i = 0; i < saveMarker.length; i += 1) {
    const { center, radius, point_list: pointList, kind } = saveMarker[i];
    if (kind === '0') {
      if (lat === '') [lat, lng] = center;

      // 円の場合
      marker.push(<Circle center={center} radius={radius} key={commons.randomNum()} />);
    } else if (kind === '1') {
      if (lat === '') {
        const intiPoint = pointList[0];
        [lat, lng] = intiPoint;
      }

      // 多角形の場合
      marker.push(<Polygon positions={pointList} key={commons.randomNum()} />);
    }
  }

  const detail = (
    <div className="listDetail">
      <div className="box-dt">
        <div className="bold">{`名称：${name}`}</div>
        {freeText === '' ? null : (
          <div>
            フリー記載<div className="ml20">{commons.shapedContents(freeText)}</div>
          </div>
        )}
        {createUrl(urlList)}
      </div>
      <div className="box-dt">{createMap(marker, lat, lng, tileUrl, tileAttribution)}</div>
    </div>
  );

  return (
    <>
      <tr className="table-row">
        <td>
          <div style={rectangleStyle} />
        </td>
        <td>
          <button type="button" className="toggle-btn" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? '[－]' : '[＋]'}&nbsp;
            {name}
          </button>
        </td>
        <td className="textRange hide-col">{freeText}</td>
      </tr>
      {isOpen && (
        <tr className="detail-row">
          <td colSpan="5" className="detail-cell">
            {detail}
          </td>
        </tr>
      )}
    </>
  );
}
